import React, { useMemo } from 'react';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { TaxCertificateFilePicker } from '../../controls';
import { ViewTaxFormPropTypes } from '../../shapes';
import { BaseViewTaxFormList } from '../../utils';
import { FileScenarioMapping } from '../../constants';

const { CountryCode } = Constants;

export const COViewTaxForm = ({
  i18n,
  filledData,
  taxCertification,
  taxFormMode,
  showLineByLineFormGroup,
  ownerAccountId,
  urlBuilder,
  showTaxCertLink,
  taxSchema,
}) => {
  const additionalFormData = useMemo(() => ({ scenario: FileScenarioMapping.CO }), []);
  return (
    <div className="colombia-view-tax-form">
      <BaseViewTaxFormList
        i18n={i18n}
        uiObject={filledData}
        taxSchema={taxSchema}
        countryCode={CountryCode.CO}
      />
      <TaxCertificateFilePicker
        i18n={i18n}
        mtTaxCertification={taxCertification}
        taxFormMode={taxFormMode}
        showLineByLineFormGroup={showLineByLineFormGroup}
        ownerAccountId={ownerAccountId}
        urlBuilder={urlBuilder}
        showTaxCertLink={showTaxCertLink}
        taxCertLabel={i18n.getString(_TL_('Tax certificate/RUT document'))}
        additionalFormData={additionalFormData}
      />
    </div>
  );
};

COViewTaxForm.propTypes = ViewTaxFormPropTypes;
